import React, { useState, useEffect, useContext } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Link } from 'wouter';
import { getJustificationsCompanyList } from '../services/api_justifications';
import { AuthContext } from '../contexts/auth';

const GiustificativiSelected = () => {
    const { loading, token } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [giustificativi, setGiustificativi] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        setIsError(false);

        const fetchData = async () => {
            try {
              const giustificativi = await getJustificationsCompanyList(token);
              setGiustificativi(giustificativi);
            } catch (error) {
              console.error('Error fetching justifications:', error);
              setIsError(true);
            } finally {
              setIsLoading(false);
            }
        };

        fetchData();
    }, [token]);

    if (isLoading) return <div>Loading...</div>;
    if (isError) return <div>Error loading data</div>;

    return (
        <fieldset>
        <div className="flex justify-between items-center my-4">
            <legend className="text-sm font-semibold leading-6 text-gray-900">I TUOI GIUSTIFICATIVI</legend>
            <Link to="giustificativi_table" className="border flex items-center rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
            Aggiungi / Modifica
            </Link>
        </div>
        <div className="mt-4 md:flex md:flex-wrap">
            {giustificativi.map((giustificativo, giustificativoIdx) => ( 
            <div key={giustificativoIdx} className="md:w-1/2 sm:w-full p-1">
                <table className="min-w-full border border-gray-200">
                <tbody className="">
                    <tr className="bg-white">
                        <td className="px-4 py-1 text-sm text-gray-700 uppercase">{giustificativo.justification.description}</td>
                    </tr>
                </tbody>
                </table>
            </div>
            ))}
        </div>
        </fieldset>
    );
};

export default GiustificativiSelected;
